<template>
  <v-expansion-panels v-model="isOpen" multiple flat>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row
          align="center"
          justify="end"
          class="px-3 deep-purple--text lighten-3 font-weight-bold"
        >
          {{ $t('common.filter') }}
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          color="deep-purple lighten-3"
          dark
          elevation="6"
          class="pa-4"
        >
          <v-row align="center" justify="space-between">
            <v-col cols="12" lg="3">
              <v-autocomplete
                :placeholder="$t('conglomerates.country')"
                flat
                solo
                light
                rounded
                dense
                :items="countries"
                item-value="id"
                item-text="name"
                v-model="value.country"
                color="white"
                single-line
                hide-details
              />
            </v-col>

            <v-col cols="12" lg="4">
              <v-text-field
                :placeholder="$t('conglomerates.conglomerate_name')"
                solo
                dense
                flat
                light
                rounded
                hide-details
                v-model="value.name"
              />
            </v-col>

            <v-col cols="12" lg="5">
              <v-row align="center" justify="space-between">
                <v-col cols="12" md="6">
                  <v-select
                    :items="statusItems"
                    v-model="value.active"
                    solo
                    dense
                    flat
                    light
                    rounded
                    hide-details
                    :placeholder="$t('conglomerates.status')"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn
                    text
                    color="white"
                    class="text-decoration-underline"
                    small
                    rounded
                    @click="reset"
                  >
                    {{ $t('common.clear_filter') }}
                  </v-btn>
                  <v-btn
                    outlined
                    rounded
                    small
                    @click="search"
                  >
                    {{ $t('common.search') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { defaultConglomerateFilter } from '@/constants/filters';

export default {
  name: 'ConglomeratesFilter',
  props: {
    countries: { type: Array, default: () => [] },
    value: { type: Object, default: () => ({ ...defaultConglomerateFilter }) },
  },
  data: () => ({
    isOpen: [],
  }),
  computed: {
    statusItems() {
      return [
        { text: this.$t('common.all'), value: null },
        { text: this.$t('conglomerates.active'), value: true },
        { text: this.$t('conglomerates.inactive'), value: false },
      ];
    },
  },
  methods: {
    reset() {
      Object.entries(this.value).forEach(([key]) => {
        // eslint-disable-next-line no-param-reassign
        this.value[key] = defaultConglomerateFilter[key];
      });
      this.$emit('reset');
    },
    search() {
      this.$emit('search');
    },
  },
};
</script>
